import cookie from 'js-cookie'

export default () => {
  return cookie
}